import { TCustomRouteObject } from '@/shared/types/router.types';

// Gated by its parent, sreHubRoutes, on the `custom:isDeveloper` claim.
export const consoleLatencyRoutes: TCustomRouteObject = {
  path: 'console-latency',
  handle: {
    crumb: {
      label: 'console_latency',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { ConsoleLatencyRoute } = await import('./console-latency');
        return { Component: ConsoleLatencyRoute };
      },
    },
  ],
};
